import React from "react";
import { connect } from "react-redux";
import StandardOrder from "./StandardOrder";
import AppStepper from "./AppStepper";
import { withRouter } from "react-router-dom";
import * as fuiRedux from "../../redux/fui/index";
import PropTypes from "prop-types";
import PlatformLicenseStepper from "./PlatformLicenseStepper";

/**
 * Fui page for platforms
 * @author Xiao Luo
 * @version 1.0
 * @see Used in component: FulfilmentUI
 */
const FuiHomePage = ({
  match: {
    params: { routeName },
  },
  classes,
}) => {
  // create function that guide to selected products
  const renderProduct = () => {
    switch (routeName) {
      case undefined:
        return <StandardOrder />;
      case "managedPlatform":
      case "dedicatedPlatform":
      case "utkmPlatform":
      case "genWizardPlatform":
      case "adPlatform":
      case "windowsProvisioningPlatform":
      case "plainInstance":
      case "plainInstanceMcc":
      case "pamInstance":
      case "automaticTicketResolver":
      case "eventOpsPlatform":
      case "quasarpp":
      case "stormseer":
      case "splunkClusterPlatform":
      case "stack360":
      case "onPremiseService":
      case "automationAnywhereLicenses":
      case "serviceIntegrator":
      case "ec2ClaudeCode":
      case "genwizardagent":
          return <PlatformLicenseStepper classes={classes} />;
      default:
        return <AppStepper classes={classes} />;
    }
  };
  return <div>{renderProduct()}</div>;
};

const MSTP = (state) => ({
  listenerClearLocalData: state.fui.listenerClearLocalData,
});
FuiHomePage.propTypes = {
  /**
   * Match property of route library
   */
  match: PropTypes.object,
  /**
   *
   */
  clearLocalComponentData: PropTypes.func,
  /**
   * Redux function to update an instance.
   */
  updateASelectedInstance: PropTypes.func,
};

export default withRouter(
  connect(MSTP, { updateASelectedInstance: fuiRedux.updateASelectedInstance })(
    FuiHomePage
  )
);
